import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardShell } from 'components/DashboardShell';
import { MissionCard } from 'components/MissionCard';
import { EmptyState, ListSkeleton } from 'components/EmptyState';
import { Tabs, TabsList, TabsTrigger, TabsContent } from 'components/ui/tabs';
import { useAuth } from 'contexts/AuthContext';
import api from 'lib/api';
import { ClipboardList } from 'lucide-react';
import { useLanguage } from 'lib/i18n';

export default function MissionsPage() {
  const { user } = useAuth();
  const { t } = useLanguage();
  const [missions, setMissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/missions').then(r => setMissions(r.data)).finally(() => setLoading(false));
  }, []);

  const grouped = {
    active: missions.filter(m => ['pending','accepted','in_progress','picked_up','in_transit','arrived_relay'].includes(m.status)),
    delivered: missions.filter(m => m.status === 'delivered'),
    other: missions.filter(m => ['cancelled','refused','dispute'].includes(m.status)),
  };

  return (
    <DashboardShell>
      <div className="mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold">{t('mission.listTitle')}</h1>
        <p className="text-muted-foreground">{missions.length} {missions.length === 1 ? t('mission.countOne') : t('mission.countMany')}</p>
      </div>
      <Tabs defaultValue="active">
        <TabsList>
          <TabsTrigger value="active" data-testid="tab-active">{t('mission.active')} ({grouped.active.length})</TabsTrigger>
          <TabsTrigger value="delivered" data-testid="tab-delivered">{t('mission.delivered')} ({grouped.delivered.length})</TabsTrigger>
          <TabsTrigger value="other" data-testid="tab-other">{t('mission.other')} ({grouped.other.length})</TabsTrigger>
        </TabsList>
        {['active','delivered','other'].map(key => (
          <TabsContent key={key} value={key}>
            {loading ? <ListSkeleton /> : grouped[key].length === 0 ? (
              <EmptyState icon={ClipboardList} title={t('mission.none')} description={t('mission.noneCategory')} />
            ) : (
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {grouped[key].map(m => <MissionCard key={m.id} mission={m} isDeliverer={m.deliverer_id === user.id} />)}
              </div>
            )}
          </TabsContent>
        ))}
      </Tabs>
    </DashboardShell>
  );
}
